import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import { ReportService } from '../../_service/report.service';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-patient-login-report',
  templateUrl: './patient-login-report.component.html',
  styleUrls: ['./patient-login-report.component.css']
})
export class PatientLoginReportComponent implements OnInit {
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  patientData:any=[];perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;search:string;start_date:string='';end_date:string='';
  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,private reportapi:ReportService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.loadData(0,this.perpage);
  }

  async loadData(pageIndex,perpage)
  {
      this.patientData = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;this.loaded = false;
      this.reportapi.getMobileLoginReport(pageIndex,perpage,qString).subscribe((data:any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if(data.status)
        {
          this.patientData = data.data;
        }
        else
        {
          this.patientData = [];
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.loading = false;
        this.loaded = true;
        this.sharedapi.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadData(event.pageIndex,event.pageSize);
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadData(0,this.perpage);
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadData(0,this.perpage);
  }

  exportLeadData()
    {
      if(this.patientData.length>0)
      {
          let data = [];
          let titles = ['Glamyo Patient Id','Name','Mobile','Last Login Date/Time'];


          data.push(titles);
          for(let key in this.patientData)
          {
             
              let exdata = [this.patientData[key].glamyo_patient_id,
                this.patientData[key].name,
                this.patientData[key].mobile,
                this.patientData[key].login_time
              ];
              data.push(exdata);
          }


          let ws = XLSX.utils.aoa_to_sheet(data);
          /* generate workbook and add the worksheet */
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

          /* save to file */
          let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
          XLSX.writeFile(wb, 'patient_mobile_app_login_'+utc+'.xlsx');
      }else{
          this.sharedapi.presentToast('No Data Found!');
      }
  }

}
